import { render, staticRenderFns } from "./list.vue?vue&type=template&id=d97ed902&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=d97ed902&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97ed902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d97ed902')) {
      api.createRecord('d97ed902', component.options)
    } else {
      api.reload('d97ed902', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=d97ed902&scoped=true", function () {
      api.rerender('d97ed902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/addressManage/list.vue"
export default component.exports